"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfilePictureView = void 0;
const react_1 = __importDefault(require("react"));
require("./ProfilePictureView.scss");
const ProfilePictureView_scss_json_1 = __importDefault(require("./ProfilePictureView.scss.json"));
const package_1 = require("../package");
const ProfilePicture_1 = require("../shapes/ProfilePicture");
const ClassNames_1 = require("lincd/lib/utils/ClassNames");
const ImageResize_1 = require("lincd-server-utils/lib/utils/ImageResize");
const helper_1 = require("../utils/helper");
//TODO: replace SHAPE with an actual Shape class
exports.ProfilePictureView = (0, package_1.linkedComponent)(ProfilePicture_1.ProfilePicture.request((p) => {
    var _a;
    return [(_a = p.cropped) === null || _a === void 0 ? void 0 : _a.contentUrl];
}), ({ linkedData, className, width = 190 }) => {
    let [contentUrl] = linkedData;
    let imageSrc = (0, ImageResize_1.getResizedImagePath)((0, helper_1.replaceLocalhostWithSiteRoot)(contentUrl), width);
    return (react_1.default.createElement("img", { className: (0, ClassNames_1.cl)(ProfilePictureView_scss_json_1.default.ProfilePictureView, className), src: imageSrc }));
});
//register all components in this file
(0, package_1.registerPackageModule)(module);
//# sourceMappingURL=ProfilePictureView.js.map